import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Tooltip, useDisclosure } from '@bonusly/design-system';

import { useSeasonalTheme } from './seasonal-theme-context';
import { SeasonalThemeModal } from './seasonal-theme-modal';

export const SeasonalToggle: FC = () => {
	const { t } = useTranslation('components');
	const { hasSeasonalThemePermission, isSeasonalThemeEnabled, toggleTheme } = useSeasonalTheme();
	const { isOpen, onOpen, onClose } = useDisclosure();

	// Only show toggle if user has permission (feature flag is enabled)
	if (!hasSeasonalThemePermission) {
		return null;
	}

	const handleClick = () => {
		if (isSeasonalThemeEnabled) {
			// If already enabled, just toggle it off
			toggleTheme();
		} else {
			// If disabled, show the modal first
			onOpen();
		}
	};

	return (
		<>
			<Tooltip label={isSeasonalThemeEnabled ? t('seasonal_theme.toggle.disable_label') : t('seasonal_theme.toggle.enable_label')} placement="left">
				<Box>
					<Button
						aria-label={isSeasonalThemeEnabled ? t('seasonal_theme.toggle.disable_label') : t('seasonal_theme.toggle.enable_label')}
						onClick={handleClick}
						size="md"
						variant="ghost"
						fontSize="24px"
						minW="auto"
						p={2}
						h="auto"
						bg={isSeasonalThemeEnabled ? 'orange.100' : 'transparent'}
						boxShadow={isSeasonalThemeEnabled ? '0 0 20px rgba(234, 88, 12, 0.6), 0 0 40px rgba(234, 88, 12, 0.3)' : 'none'}
						_hover={{
							bg: isSeasonalThemeEnabled ? 'orange.100' : 'orange.50',
							transform: 'scale(1.1)',
							boxShadow: isSeasonalThemeEnabled ? '0 0 25px rgba(234, 88, 12, 0.8), 0 0 50px rgba(234, 88, 12, 0.4)' : 'none',
						}}
						transition="all 0.2s"
					>
						🎃
					</Button>
				</Box>
			</Tooltip>

			<SeasonalThemeModal isOpen={isOpen} onClose={onClose} onEnable={toggleTheme} />
		</>
	);
};
